<template>
	<div class="mood-stream">
		<div class="mood-stream__table">
			<div class="filter">
				<AppDateRangePicker
					class="filter__date"
					placeholder="Select dates"
					v-model="dateFilter"
					:disabled="historyLoading"
				/>

				<AppButton
					modifier="small-secondary"
					@click="getHistory()"
					:disabled="historyLoading || isApplyDisabled"
				>
					Apply
				</AppButton>

				<p>Average mood: {{ user.average_emotion | capitalize | null }}</p>
				<p>Average stress level:&nbsp;
					<span
						class="stress-level"
						:class="`stress-level--${'normal'}`"
					>
						{{ user.average_stress_level | null }}
					</span>
				</p>
			</div>

			<AppTable
				:fields="fields"
				:dataset="history.data"
				:checkbox="false"
				:loading="historyLoading"
			>
				<template #date_created="{ props: { item } }">
					{{ item.date_created | dateFormatter('ll') }}
				</template>

				<template #time_created="{ props: { item } }">
					{{ item.time_created | time('h:mm') }}
				</template>

				<template #loading>
					<AppLoading/>
				</template>
			</AppTable>

			<div class="mood-stream__pagination">
				<p>
					{{`${history.from || ''}-${history.to || ''}`}}
				</p>

				<AppCountPicker
					placeholder="Item"
					min="30"
					max="60"
					step="20"
					v-model="count"
					:disabled="historyLoading"
                    @change="getHistory()"
				/>

				<AppPagination
					v-model="page"
					:total="history.last_page"
					:disabled="historyLoading"
                    @change="getHistory(false)"
				/>
			</div>
		</div>

		<div class="mood-stream__side-panel">
			<UserReportForm action="user/getUserProfileDetails"/>

			<div class="mood-stream__calendar-wrapper">
				<AppCalendar
					v-model="calendarDate"
					@navigate="getCalendar"
					class="mood-stream__calendar"
				>
					<template #date="{ props }">
						<div class="date">
							<div
								class="date__value"
								:class="{
									'date__value--today' : props.isToday,
									'date__value--selected' : props.isSelected
								}"
							>
								{{ props.date.getDate() }}
							</div>

							<div class="date__image">
								<AppImage
									v-if="calendarMoods[props.date.getTime()] &&
										!calendarLoading"
									class="image"
									title="emotion"
									:src="calendarMoods[props.date.getTime()]"
									:fallback="require('@/assets/img/default-emoji.png')"
								/>
							</div>
						</div>
					</template>
				</AppCalendar>

				<!-- <LayoutBox
					class="mood-stream__emotion-card"
					v-if="showEmotionCard && !dailyLoading"
				>
					<span
						class="close"
						@click="showEmotionCard=false"
					>
						&times;
					</span>

					<UserEmotionCard
						title="Current Emotion"
						:sticker="daily.filepath"
						:bpm="daily.heartbeat_count"
						:stress="daily.stress_level"
						:mood="daily.emotion_value"
						:moodDate="moodDate"
						:percent="dailyPercentage"
					></UserEmotionCard>

				</LayoutBox> -->

				<div
					v-if="calendarLoading"
					class="mood-stream__loading"
				>
					<AppLoading/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
// import UserEmotionCard from './UserEmotionCard.vue'
import UserReportForm from './UserReportForm'

export default {
	props: ['id'],

	created () {
		// this.getDaily(new Date())
		this.getHistory()
		this.getCalendar(new Date())
	},

	computed: {
		calendarMoods () {
			// const { filters } = this.$options
			return this.calendar.reduce((values, current) => {
				const date = new Date(current.date).getTime()
				values[date] = `${this.URL}img/resources/${current.filepath}`
				return values
			}, {})
		},

		isApplyDisabled () {
			if (this.dateFilter) return this.dateFilter[0] === null || this.dateFilter[1] === null
			return true
		},

		// dailyPercentage () {
		// 	return parseInt(`${this.daily.upmood_meter + 1}0`)
		// },

		// moodDate () {
		// 	const { filters } = this.$options
		// 	let date = this.calendarDate

		// 	if (!this.calendarDate) {
		// 		date = new Date()
		// 	}

		// 	return filters.dateFormatter(date, 'MMMM D, YYYY')
		// },

		...mapGetters('user', {
			calendar: 'getCalendar',
			calendarLoading: 'getCalendarLoading',
			// daily: 'getDaily',
			// dailyLoading: 'getDailyLoading',
			history: 'getHistory',
			historyLoading: 'getHistoryLoading',
			user: 'getUserView'
		}),

		...mapFields('user', {
			calendarDate: 'calendarDate'
		})
	},

	data () {
		return {
			URL: process.env.VUE_APP_BASE,
			showEmotionCard: false,

			fields: [
				{ name: 'date_created', text: 'Date' },
				{ name: 'time_created', text: 'Time' },
				{ name: 'heartbeat_count', text: 'BPM' },
				{ name: 'ppi', text: 'No of PPI' },
				{ name: 'total_ppi', text: 'Total Sum' },
				{ name: 'stress_level', text: 'Stress Level' },
				{ name: 'emotion_name', text: 'Emotion', style: 'text-transform: capitalize;' },
				{ name: 'profile_post', text: 'Status' }
			],

			dateFilter: [ new Date(), new Date() ],
			count: 30,
			page: 1
		}
	},

	methods: {
		// selectMoodDate (props) {
		// 	props.select(props.date)
		// 	this.getDaily()
		// 	this.showEmotionCard = true
		// },

		dateFormatter (date, format = 'YYYY-MM-DD') {
			const { filters } = this.$options
			return filters.dateFormatter(date, format)
		},

		showCard (date) {
			this.getDaily(date)
			this.showEmotionCard = true
		},

		// getDaily (date = null) {
		// 	let calendarDate = this.calendarDate

		// 	if (date) {
		// 		calendarDate = date
		// 	}

		// 	calendarDate = this.dateFormatter(calendarDate)

		// 	const dailyParams = `?id=${this.id}&date=${calendarDate}`

		// 	this.$store.dispatch('user/getDailyCalendar', dailyParams)
		// },

		async getHistory (resetPage = true) {
			this.page = resetPage ? 1 : this.page
			let query = `?id=${this.id}&page=${this.page}&count=${this.count}`
			let dateFrom = this.dateFormatter(this.dateFilter[0])
			let dateTo = this.dateFormatter(this.dateFilter[1])
			query += `&date_from=${dateFrom}&date_to=${dateTo}`
			this.$store.dispatch('user/getHistory', query)
		},

		getCalendar (e) {
			const currentDate = this.dateFormatter(e, 'YYYY-MM')
			const calendarParams = `?id=${this.id}&date=${currentDate}`

			this.$store.dispatch('user/getCalendar', calendarParams)
		}
	},

	components: {
		// UserEmotionCard,
		UserReportForm
	}
}
</script>

<style lang="scss" scoped>
.mood-stream {
	width: 100%;
	display: flex;
	padding-right: 100px;

	.filter {
		display: flex;
		align-items: center;
		margin-bottom: 1em;

		> * { margin-right: 1em; }
		&__date { width: 200px; }
		width: 100%;
	}

	&__table {
		width: 100%;
		margin-right: 1.5em;
		height: 350px;
	}

	&__pagination {
		margin-top: 10px;
		width: 100%;
		display: flex;
		align-items: center;

		> *:first-child { margin-right: auto; }
		> *:not(:first-child) { margin-left: 20px; }
	}

	&__side-panel {
		flex-shrink: 0;
		min-width: 250px;
	}

	&__report {
		padding: .6em;
		border: 1px dashed lighten($default-light, 10%);
		margin-bottom: 1.5em;

		.report {
			&__controls {
				display: flex;
				justify-content: space-between;
				margin: 10px 0;

				> * { width: 48%; }
			}

			&__filter {
				margin: .5em 0;
			}
		}

		.clear {
			text-align: right;
			border: none;
			background: none;
			font-size: .9em;

			a {
				text-decoration: none;
				color: $danger;
			}
		}
	}

	&__report-wrapper { position: relative; }

	&__calendar-wrapper {
		position: relative;
		height: 30em;
	}

	&__emotion-card {
		position: absolute;
		top: 0;
		padding: 10px;
		width: 100%;
		height: 100%;

		.close {
			position: absolute;
			top: 10px;
			right: 10px;
			font-size: 1.2em;
			color: $danger;
			cursor: pointer;
		}
	}

	&__calendar {
		height: 100%;

		.date {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin: .5em;
			font-size: .8em;

			&__value {
				height: 2em;
				width: 2em;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 2px;
				border-radius: 50%;
				padding: 1px;
				cursor: pointer;

				&:hover {
					background-color: #f4f4f4;
				}

				&--today { color: $secondary; }
				&--selected {
					&, &:hover {
						background-color: lighten($secondary, 30%);
						color: $secondary;
					}
				}
			}

			&__image {
				margin: 1px;
				width: 2em;
				height: 2em;

				.image {
					width: 100%;
					height: 100%;
				}
			}
		}
	}

	&__loading {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		background-color: #ffffff77;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.stress-level {
		text-transform: capitalize;

		&--normal { color: #FFB921; }
		&--low { color: #44B1ED; }
		&--mild { color: #2ab27b; }
		&--high { color: #F4949A; }
	}
}
</style>
